import { missingWidget } from '../utils/helpers';

export default function cardsBackground() {
  const widgetName = 'cardsBackground';
  const $widget = $(`#${widgetName}`);
  const widgetOpts = typeof cardsBackgroundOpts === 'undefined' ? null : cardsBackgroundOpts;

  if (!widgetOpts) {
    missingWidget(widgetName);
    return;
  }

  const mainFeatureElement = '.cards-container';

  return saffire.widgets.cardWidget($widget, {
    currentWidgetModuleItemID: widgetOpts.currentWidgetModuleItemID,
    scriptPath: widgetOpts.scriptPath,

    cardWidgetLoaded: function (data, _owl, hasData) {
      if (hasData) {
        addMainFeatureBackground(data.items[0], mainFeatureElement);
      }
      $widget.remove();
    },
  });
}

function addMainFeatureBackground(widgetData, featureTarget) {
  const { ImageWithPath } = widgetData;

  $(`${featureTarget}`).css({
    background: `url('${ImageWithPath}') no-repeat center top/cover`,
  });
}
